import { isFeatureEnabled } from 'owa-feature-flags';
import mailStore from 'owa-mail-store/lib/store/Store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { getExtendedPropertyUri } from 'owa-service/lib/Utils';
import doesItemContainCardData from './doesItemContainCardData';

export const featureId = 'MessageCard';

export const MESSAGE_CARD_PROPERTY_NAME = 'IOpenTypedFacet.Com.Microsoft.Graph.MessageCard';
const PROPERTY_SET_GUID = 'E550B918-9859-47B9-8095-97E4E72F1926';
const extendedPropertyUri = getExtendedPropertyUri(
    PROPERTY_SET_GUID,
    MESSAGE_CARD_PROPERTY_NAME,
    'String'
);

const isPropertyExistedOnItem = (itemId: string): boolean => {
    const item = mailStore.items.get(itemId);
    return !!item?.adaptiveCardDetails;
};

const shouldGetItemPropertiesFromServer = (
    itemId: string,
    listviewType: ReactListViewType
): boolean => {
    if (!isFeatureEnabled('rp-actionableMessages')) {
        return false;
    }

    const item = mailStore.items.get(itemId);
    return doesItemContainCardData(item);
};

const messageCardItemPropertyEntry = {
    featureId: featureId,
    propertyPaths: [extendedPropertyUri],
    isPropertyExistedOnItem: isPropertyExistedOnItem,
    shouldGetItemPropertiesFromServer: shouldGetItemPropertiesFromServer,
};

export default messageCardItemPropertyEntry;
